import React from "react";
import AjudaModal from "./AjudaModal";

function AjudaCataleg({ pestanya, onTancar }) {
  const contingut = CONTINGUT[pestanya] || CONTINGUT.productes;
  return (
    <AjudaModal
      id="cataleg-ajuda-title"
      titol={contingut.titol}
      lead={contingut.lead}
      onTancar={onTancar}
    >
      {contingut.cos}
    </AjudaModal>
  );
}

const CONTINGUT = {
  categories: {
    titol: "Com funcionen les Categories",
    lead: "La categoria és el calaix gros del catàleg: agrupa tipus de material i, més avall, materials i productes.",
    cos: (
      <>
        <section className="dv2-help-section">
          <h4>Llista</h4>
          <ul>
            <li>Doble clic a la fila per consultar. El menú <strong>…</strong> obre Consultar, Modificar o Esborrar.</li>
            <li><strong>Nova categoria</strong> obre la fitxa buida. La cerca filtra pel nom.</li>
          </ul>
        </section>
        <section className="dv2-help-section">
          <h4>Fitxa</h4>
          <p>
            Nom i, si cal, descripció. No es pot esborrar si encara té tipus de material a sota: primer cal buidar-los
            o moure'ls.
          </p>
        </section>
      </>
    ),
  },
  tipusmaterials: {
    titol: "Com funcionen els Tipus de materials",
    lead: "El tipus va a sota d'una categoria. És el pas del mig: Categoria → Tipus → Material → Producte.",
    cos: (
      <>
        <section className="dv2-help-section">
          <h4>Llista</h4>
          <ul>
            <li>Doble clic per consultar. El <strong>…</strong> obre Consultar, Modificar o Esborrar.</li>
            <li>Pots filtrar per categoria. <strong>Nou tipus</strong> obre la fitxa.</li>
          </ul>
        </section>
        <section className="dv2-help-section">
          <h4>Fitxa</h4>
          <p>
            Tries la categoria i poses el nom del tipus. Des d'un producte o un material també el pots crear sense
            sortir-ne. No esborra si té materials a sota.
          </p>
        </section>
      </>
    ),
  },
  materials: {
    titol: "Com funcionen els Materials",
    lead: "El material és la família concreta (el que es compra o s'instal·la), dins d'un tipus. Els productes del catàleg en pengen.",
    cos: (
      <>
        <section className="dv2-help-section">
          <h4>Llista</h4>
          <ul>
            <li>Doble clic per consultar. El <strong>…</strong> obre Consultar, Modificar o Esborrar.</li>
            <li>Filtres de categoria i tipus. <strong>Nou material</strong> obre la fitxa.</li>
            <li>
              <strong>Estoc físic</strong> es calcula en consultar, amb els productes d'aquest material a l'empresa
              seleccionada. Un pack amb la composició activa no suma el pare.
            </li>
          </ul>
        </section>
        <section className="dv2-help-section">
          <h4>Fitxa</h4>
          <p>
            Categoria, tipus i nom. Si el tipus encara no existeix, el pots crear des d'aquí. Un material amb productes
            associats no es deixa esborrar.
          </p>
        </section>
      </>
    ),
  },
  productes: {
    titol: "Com funcionen els Productes",
    lead: "El catàleg de marca i model. Dins de cada producte hi ha dades, preus de proveïdor, atributs tècnics i, si és un pack, la composició.",
    cos: (
      <>
        <section className="dv2-help-section">
          <h4>Llista</h4>
          <ul>
            <li>Doble clic per consultar. El <strong>…</strong> obre Consultar, Modificar, Esborrar i les seccions (Preus, Atributs, Pack).</li>
            <li>Filtres de categoria, tipus i material. La cerca mira marca, model i referència.</li>
            <li>
              <strong>Estoc físic</strong>, <strong>Reservat</strong> i <strong>Disponible</strong> són de l'empresa
              seleccionada. Reservat és el que ja està compromès per tasques. Disponible és la diferència.
            </li>
          </ul>
        </section>
        <section className="dv2-help-section">
          <h4>Seccions</h4>
          <p>
            Un cop dins: <strong>Dades</strong>, <strong>Preus proveïdors</strong> i <strong>Atributs</strong>. Si el
            producte és un pack, també surt <strong>Pack</strong>.
          </p>
        </section>
      </>
    ),
  },
  producteFitxa: {
    titol: "Com funciona la fitxa del Producte",
    lead: "Classifica el producte (categoria, tipus, material) i omple marca, model i referència. El preu de venda el marquen els proveïdors, no aquesta fitxa.",
    cos: (
      <>
        <section className="dv2-help-section">
          <h4>Classificació</h4>
          <p>
            Tria Categoria → Tipus → Material. Si encara no existeixen, el <strong>+ Nou</strong> els crea sense
            sortir. Marca <strong>Pack</strong> si aquest producte és un conjunt d'altres. L'estoc físic és el de
            l'empresa seleccionada. El reservat i el disponible es consulten: les reserves es gestionen a la logística
            de la tasca. <strong>Traslladar</strong> mou el que hi ha en una ubicació cap a una altra de la mateixa
            empresa. No canvia l'estoc total ni les reserves. <strong>Regularitzar estoc</strong> corregeix un
            recompte: en suma o en treu, amb un motiu obligatori, i no toca les reserves. En un pack amb la composició
            activa es mouen o es corregeixen els components, i només si a l'origen hi són tots.
          </p>
        </section>
        <section className="dv2-help-section">
          <h4>Després de desar</h4>
          <p>
            A <strong>Preus proveïdors</strong> poses qui el ven i a quin preu (el més barat surt per defecte a
            partides i tasques). A <strong>Atributs</strong>, mesures i dades tècniques. Al <strong>Pack</strong>, quins
            productes el formen.
          </p>
        </section>
      </>
    ),
  },
  preus: {
    titol: "Com funcionen els Preus de proveïdor",
    lead: "Cada línia és «aquest proveïdor ven aquest producte a aquest preu». El més econòmic és el que es proposa després a partides i tasques.",
    cos: (
      <>
        <section className="dv2-help-section">
          <h4>Llista</h4>
          <ul>
            <li>Doble clic per consultar. El <strong>…</strong> obre Consultar, Modificar o Esborrar.</li>
            <li><strong>Nou preu</strong>: tries proveïdor, preu i, si cal, referència del proveïdor.</li>
          </ul>
        </section>
        <section className="dv2-help-section">
          <h4>Fitxa del preu</h4>
          <p>
            Un producte pot tenir diversos proveïdors. Canviar el preu aquí no modifica ofertes ja recollides en un
            pressupost o treball.
          </p>
        </section>
      </>
    ),
  },
  atributs: {
    titol: "Com funcionen els Atributs",
    lead: "Fitxa tècnica del producte: nom de l'atribut, unitat i valors (nominal, mínim, màxim).",
    cos: (
      <>
        <section className="dv2-help-section">
          <h4>Què pots fer</h4>
          <ul>
            <li>En consulta només es llegeix. <strong>Editar</strong> deixa afegir, canviar o treure files.</li>
            <li>Deixa en blanc el que no calgui. <strong>Desar</strong> guarda tot el joc d'atributs.</li>
          </ul>
        </section>
      </>
    ),
  },
  pack: {
    titol: "Com funciona el Pack",
    lead: "Un pack és un producte fet d'altres productes del catàleg. Aquí dius quins i en quina quantitat.",
    cos: (
      <>
        <section className="dv2-help-section">
          <h4>Què pots fer</h4>
          <ul>
            <li><strong>Editar</strong> per afegir o treure components i canviar quantitats. Això no mou l'estoc.</li>
            <li>
              <strong>Activar composició</strong> converteix l'estoc i les reserves del pack en components. Després la
              composició queda tancada.
            </li>
            <li>El pack s'ha d'haver marcat a la fitxa de Dades. Si no és pack, aquesta secció no surt.</li>
          </ul>
        </section>
      </>
    ),
  },
};

export default AjudaCataleg;
